<template>
    <v-card height="350px">
        <v-navigation-drawer absolute fixed>
            <v-toolbar flat class="transparent">
                <v-list class="pa-0">
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <img v-bind:src="photo">
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{name}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-toolbar>

            <v-list>
                <template v-for="item in items">
                    <v-list-group
                            v-if="item.children"
                            v-model="item.model"
                            :key="item.text"
                            :prepend-icon="item.model ? item.icon : item['icon-alt']"
                            append-icon=""
                    >
                        <v-list-tile slot="activator">
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.text }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>


                        <v-list-tile
                                v-for="(child, i) in item.children"
                                :key="i"
                                @click=""
                        >
                            <v-list-tile-action v-if="child.icon">
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ child.text }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list-group>
                    <v-list-tile v-else :key="item.text" @click="">
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{ item.text }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-navigation-drawer>
    </v-card>
</template>

<script>
    export default {
        name: "LeftEmployeePanel",
        props: [
            'name', 'photo'
        ],
        methods: {
            moveTo(page){

            }
        },
        data: () => ({
            items: [
                {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'Insurance',
                    model: false,
                    children: [
                        {icon:'person_pin', text: 'Personal', link: 'insurance_personal'},
                        {icon:'business_center', text: 'Business', link: 'insurance_business'}
                    ]
                }, {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'Accounting',
                    model: false,
                    children:[
                        {icon:'person_pin', text: 'Personal', link: 'cpa_personal'},
                        {icon:'business_center', text: 'Business', link: 'cpa_business'}
                    ]
                }
            ]
        })
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/employee/partials/LeftEmployeePanel.vue